<template>
  <baseEdit />
</template>

<script>
  import baseEdit from './baseEdit';

  export default {
    name: 'financeAccountDetail',
    components: {
      baseEdit,
    },
  };
</script>
